<div class="ticket--header">
  <div class="flex gap-4 items-center flex-wrap">
    <div
      class="no-border h-22 padding-x-8 rounded-4"
      [class.box-yellow-08]="
        (ticketResource.hasValue() && ticketResource.value().ticket.opened) ||
        ticketResource.isLoading()
      "
      [class.box-red]="ticketResource.error()"
      [class.box-purple]="
        ticketResource.hasValue() && !ticketResource.value().ticket.opened
      "
    >
      {{ category() }}
    </div>
    <p>
      {{ ticketResource.value()?.ticket?.title }}
    </p>
    <button class="ticket--refresh-button s-24" (click)="refreshTicket()">
      <svg-icon
        class="panel-icon flex items-center justify-center s-14"
        src="assets/icons/ui/refresh.svg"
        [class.icon-rotating]="isShowRefreshAnimation()"
      ></svg-icon>
    </button>
  </div>
  <p class="ticket--associated modal-description">
    {{ ticketResource.value()?.ticket?.associated ?? "" }}
  </p>
  <p class="ticket--opened modal-description">
    @if (ticketResource.value()?.ticket?.opened) {
    {{
      ticketResource.value()?.ticket?.opened | date : "MMM d, yyyy, h:mm:ss a"
    }}
    }
  </p>
</div>
<div class="divider ticket--divider w-full horizontal"></div>
<div class="ticket--chat scrollbar" #messagesRef>
  @if (ticketResource.error()) {
  <div
    animate.enter="animate-fade-in"
    style="text-align: center; max-width: 80%"
    class="absolute-center flex flex-col gap-4 items-center justify-center w-full h-full"
  >
    {{ ticketResource.error() }}
    <button
      class="button button--style-primary h-32 padding-x-12 rounded-4"
      (click)="ticketResource.reload()"
    >
      Reload
    </button>
  </div>
  }
  <!--  -->
  @if (ticketResource.hasValue()) { @for (message of messages(); track
  (message.__id ?? $index)) {
  <app-chat-support-message
    animate.enter="animate-fade-in"
    [id]="$index"
    [message]="message"
    [messageFeatureBadges]="[
      {
        title: formatDate(message.time)
      }
    ]"
  >
  </app-chat-support-message>
  }@empty {
  <div
    style="text-align: center; max-width: 80%; cursor: default"
    class="absolute-center flex flex-col items-center justify-center w-full h-full"
  >
    <h3 class="modal-title">No messages yet</h3>
  </div>
  } }
</div>
<app-chat-send-message
  [disabled]="
    ticketResource.value()?.ticket?.status === 'Closed' ||
    ticketResource.isLoading() ||
    !!ticketResource.error()
  "
  (sendMessage)="respondToTicket($event)"
>
  <div class="ticket--actions" extra-actions>
    <button
      animate.enter="animate-fade-in"
      [disabled]="
        ticketResource.value()?.ticket?.status === 'Closed' ||
        ticketResource.isLoading() ||
        ticketResource.error()
      "
      class="button button--style-primary padding-x-12 rounded-4 h-36 ticket--action-button"
      (click)="closeTicket()"
    >
      {{
        ticketResource.value()?.ticket?.status === "Closed"  ? `This ticket was closed ${sessionService.is_admin() ? '' : `by ${closedByUser() ? 'you' : 'staff'}`}` : "Close ticket" }}
    </button>
    @if (ticketResource.value()?.ticket?.status === "Closed") {
    <button
      animate.enter="animate-fade-in"
      class="button button--style-primary padding-x-12 rounded-4 h-36 ticket--action-button reopen"
      (click)="reOpenTicket()"
      [disabled]="!sessionService.is_admin() && !closedByUser()"
    >
      Reopen ticket
    </button>
    }
  </div>
</app-chat-send-message>
@if (ticketResource.isLoading()) {
<div class="ticket--loader">
  <app-loading-icon
    animate.enter="animate-fade-in"
    class="ticket--loader__icon"
    [color]="'var(--yellow)'"
    [size]="'48px'"
  />
</div>
}
